import AcxButton from "components/UI/AcxButton";
import AcxDialog from "components/UI/Dialog/AcxDialog";
import { observer } from "mobx-react";
import SignalsPageStore from "../../Store/SignalsPageStore";
import SignalsCardSelectorStore, {
    REPORTS_ITEM_GROUP,
} from "./SignalsCardSelectorStore";
import { useStore } from "utils/useStore";
import AddCardsDialogContent from "./AddCardsDialogContent";

export const AddCardsDialog = observer(() => {
    const signalsPageStore = useStore(SignalsPageStore);
    const signalsCardSelectorStore = useStore(SignalsCardSelectorStore);

    const currentChartCount =
        signalsCardSelectorStore.selectedReportCards.length +
        (signalsPageStore.currentDashboard?.signalsChartCount ?? 0);

    return (
        <AcxDialog
            title={"Add Card(s)"}
            subTitle={
                signalsCardSelectorStore.selectedItemGroup ===
                REPORTS_ITEM_GROUP
                    ? "Report Count: " +
                      (signalsCardSelectorStore.selectedReportCards.length +
                          (signalsPageStore.currentDashboard
                              ?.signalsChartCount ?? 0))
                    : ""
            }
            dialogContentChildren={<AddCardsDialogContent />}
            isOpen={signalsCardSelectorStore.showReportSelector}
            onClose={() => {
                signalsCardSelectorStore.resetSelections();
            }}
            maxWidth={false}
            disableEnforceFocus
        >
            <AcxButton
                color="primary"
                onClick={() => {
                    signalsPageStore.currentDashboard?.addSelectedCardsToDashboard();
                }}
                disabled={
                    (signalsCardSelectorStore.selectedCards.length === 0 &&
                        signalsCardSelectorStore.selectedInsights.length ===
                            0) ||
                    currentChartCount > 20
                }
                loading={signalsPageStore.currentDashboard?.getTaskLoading(
                    "AddCards",
                )}
                sx={{ whiteSpace: "nowrap" }}
            >
                Add Card(s) to Dashboard
            </AcxButton>
        </AcxDialog>
    );
});

export default AddCardsDialog;
